import { FC } from "react";
import { IconPropsType } from ".";

export const Link: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8851_1092)">
        <path
          d="M3.03516 6.5708L1.76777 5.30341C0.791456 4.3271 0.791456 2.74419 1.76777 1.76788V1.76788C2.74408 0.791567 4.32699 0.791567 5.3033 1.76788L5.89977 2.36434L8.03516 4.49973C8.60727 5.07185 8.60727 5.99944 8.03516 6.57156V6.57156"
          stroke={props.color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M5.53516 5.53564V5.53564C4.70673 6.36407 4.70673 7.70722 5.53516 8.53564L8.03516 11.0356C8.86358 11.8641 10.2067 11.8641 11.0352 11.0356V11.0356"
          stroke={props.color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M9.53516 9.03564V9.03564C10.3636 8.20722 11.7067 8.20722 12.5352 9.03564L14.2852 10.7856C15.2517 11.7521 15.2517 13.3191 14.2852 14.2856V14.2856C13.3187 15.2521 11.7517 15.2521 10.7852 14.2856L10.0352 13.5356"
          stroke={props.color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8851_1092">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
